import { action, observable, computed, toJS } from 'mobx'

const STORE_SEALNUMS = 'sealnums'


class SealnumsStore {
    configStore

    constructor(rawState = {}, configStore) {
        this.configStore = configStore

        if (rawState.sealnums) {
            this.setSealnums(rawState.sealnums)
        }
    }
    toJS() {
        return {
            sealnums: toJS(this.sealnums)
        }
    }

    @observable sealnums = []
    @action setSealnums(value) {
        this.sealnums = value
    }
}

export { SealnumsStore, STORE_SEALNUMS }